import { Avatar, Button, Card, Divider, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { translation } from "../../../../i18n/translationConstant";
import {
  Accounts,
  GetConsentByIdResponse,
} from "../../../../Models/Response/Consent/GetConsentById";
import { ConsentStatusType } from "../../../../Utils/Constants/consentTypes";
import "./index.css";

interface IActiveConsentProps {
  consentDetailsById: GetConsentByIdResponse;
  type: string;
  onConsentStatusUpdate: (type: string) => void;
}

const ConsentByStatus: React.FC<IActiveConsentProps> = ({
  consentDetailsById,
  type,
  onConsentStatusUpdate,
}) => {
  const { t } = useTranslation();

  const [linkAccountsToShow, setLinkedAccountsToShow] = useState<Accounts[]>(
    []
  );

  const [isViewAll, setViewAll] = useState(false);

  useEffect(() => {
    setLinkedAccountsToShow(consentDetailsById.Accounts.slice(0, 2));
  }, [consentDetailsById.Accounts]);

  const viewAll = () => {
    if (isViewAll) {
      setLinkedAccountsToShow(consentDetailsById.Accounts.slice(0, 2));
    } else {
      setLinkedAccountsToShow(consentDetailsById.Accounts);
    }
    setViewAll(!isViewAll);
  };

  const { Text } = Typography;

  const revokeConsent = () => {
    onConsentStatusUpdate(ConsentStatusType.REVOKED);
  };

  const activateConsent = () => {
    onConsentStatusUpdate(ConsentStatusType.ACTIVE);
  };

  const secondaryButtonClick = () => {
    type === ConsentStatusType.ACTIVE
      ? onConsentStatusUpdate(ConsentStatusType.PAUSED)
      : revokeConsent();
  };

  const primaryButtonClick = () => {
    type === ConsentStatusType.ACTIVE
      ? onConsentStatusUpdate(ConsentStatusType.REVOKED)
      : activateConsent();
  };

  return (
    <>
      <div className="consentDetailsSubRoot">
        <div className="consentDetailsAccounts">
          {type !== ConsentStatusType.REJECTED &&
          type !== ConsentStatusType.EXPIRED ? (
            <>
              {linkAccountsToShow &&
                linkAccountsToShow.length &&
                linkAccountsToShow.map((accounts, index) => (
                  <Card
                    hoverable={false}
                    key={index}
                    className="accountCard"
                    id={index.toString()}
                  >
                    <Avatar className="consentAvatar" src={accounts.logoUrl} />

                    <div className="accountInfo">
                      <Text className="accountCardFIP">{accounts.fipName}</Text>
                      <br />
                      <div>
                        <Text className="accountCardNumber">
                          {accounts.maskedAccNumber}
                        </Text>
                        <Divider type="vertical" />
                        <Text className="accountCardAccountType">
                          {accounts.accType}
                        </Text>
                      </div>
                    </div>
                  </Card>
                ))}
            </>
          ) : (
            <></>
          )}
        </div>
        {type === ConsentStatusType.PAUSED ||
        type === ConsentStatusType.ACTIVE ? (
          <div className="activeButtonGroup">
            <Button
              className="commonButtonBackground secondaryButton width40Pmargintop0"
              onClick={secondaryButtonClick}
            >
              {type === ConsentStatusType.ACTIVE
                ? t(translation.lblPause)
                : t("lblRevoke")}
            </Button>

            <Button
              className="commonButtonBackground primaryButton linkAccountNoAccounts primaryButtonWidth"
              onClick={primaryButtonClick}
            >
              {type === ConsentStatusType.ACTIVE
                ? t(translation.lblRevoke)
                : t("lblReactivateConsent")}
            </Button>
          </div>
        ) : (
          <></>
        )}
      </div>
      {linkAccountsToShow && linkAccountsToShow.length > 2 ? (
        <Button type="text" className="viewAllButton" onClick={viewAll}>
          {isViewAll ? "View less" : "View all"}
        </Button>
      ) : (
        <></>
      )}
    </>
  );
};

export default ConsentByStatus;
